export enum TalentDatabaseLocalStorageKeys {
  TALENT_DATABASE_VALUES = 'talent-database-values',
}
